import React from 'react';
import { ComponentStory, ComponentMeta } from '@storybook/react';

import Component, { NamedAvatar as NamedAvatarComponent } from './Avatar';

export default {
  title: 'uikit/Avatar',
  component: Component,
  argTypes: {},
} as ComponentMeta<typeof Component>;

const Template: ComponentStory<typeof Component> = (args) => <Component {...args} />;
const TemplateNamedAvatar: ComponentStory<typeof NamedAvatarComponent> = (args) => <NamedAvatarComponent {...args} />;

export const Avatar = Template.bind({});
export const NamedAvatar = TemplateNamedAvatar.bind({});

Avatar.args = {
  src: '',
  fullName: 'Zakhar Moody',
};
NamedAvatar.args = {
  userName: 'Zakhar Moody',
  size: 's',
  isSquared: true,
};
